const AUTH_STATE_KEY = 'authState';
const TOKEN_KEY = 'token';
const USER_KEY = 'user';

function parseJson(value) {
  if (!value) {
    return null;
  }
  try {
    return JSON.parse(value);
  } catch (_) {
    return null;
  }
}

function buildLegacyUser(auth = {}) {
  const userUuid = auth.userUuid || auth.user?.userUuid;
  const userName = auth.userName || auth.user?.userName;
  if (!userUuid && !userName) {
    return null;
  }
  return { userUuid, userName };
}

export function getAuthState() {
  const state = parseJson(localStorage.getItem(AUTH_STATE_KEY)) || {};
  const legacyToken = localStorage.getItem(TOKEN_KEY);
  const legacyUser = parseJson(localStorage.getItem(USER_KEY));
  const accessToken = state.accessToken || state.token || legacyToken || null;
  const refreshToken = state.refreshToken || null;
  const tokenType = state.tokenType || 'Bearer';
  const expiresIn = state.expiresIn ?? null;
  const issuedAt = state.issuedAt ?? null;
  const user = state.user || legacyUser || null;

  if (!accessToken && !refreshToken && !user) {
    return null;
  }

  return {
    ...state,
    accessToken,
    refreshToken,
    tokenType,
    expiresIn,
    issuedAt,
    user,
  };
}

export function getAccessToken() {
  const auth = getAuthState();
  return auth?.accessToken || null;
}

export function getRefreshToken() {
  const auth = getAuthState();
  return auth?.refreshToken || null;
}

export function getToken() {
  return getAccessToken();
}

export function getUser() {
  const auth = getAuthState();
  return auth?.user || null;
}

export function saveAuth(auth = {}) {
  const accessToken = auth.accessToken || auth.token || null;
  const refreshToken = auth.refreshToken || null;
  const tokenType = auth.tokenType || 'Bearer';
  const expiresIn = auth.expiresIn ?? null;
  const issuedAt = auth.issuedAt ?? Date.now();
  const user = auth.user || buildLegacyUser(auth);

  const state = {
    accessToken,
    refreshToken,
    tokenType,
    expiresIn,
    issuedAt,
    user,
  };
  localStorage.setItem(AUTH_STATE_KEY, JSON.stringify(state));

  if (accessToken) {
    localStorage.setItem(TOKEN_KEY, accessToken);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }

  if (user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  } else {
    localStorage.removeItem(USER_KEY);
  }
}

export function clearAuth() {
  localStorage.removeItem(AUTH_STATE_KEY);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}
